<mat-form-field [floatLabel]="'auto'">
    <mat-select [(value)]="value" [compareWith]="compareOptions">
        <mat-option *ngFor="let option of options" [value]="option.value">
            {{ option.displayName }}
        </mat-option>
    </mat-select>
</mat-form-field>
